import React from 'react'
import ReactDOM from 'react-dom'
import { Components } from '@src/containers/ElamaIndex'

ReactDOM.render(<Components.Statistics />, document.getElementById('index-statistics'))
